import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import toast from './utils/Toast';
import Loader from './utils/Loader';
import Navbar from './utils/Navbr';
import './style/Postback.css';

const TestPostback = () => {
    const navigate = useNavigate();

    // --- State ---
    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState(null);
    const [globalPostback, setGlobalPostback] = useState('');

    // Test State
    const [testLoading, setTestLoading] = useState(false);
    const [testResult, setTestResult] = useState(null);

    const getCookie = (name) => {
        const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : null;
    };

    // --- Fetch Data ---
    useEffect(() => {
        const authToken = getCookie('authToken');
        const fetchData = async () => {
            try {
                setLoading(true);

                // 1. Auth Check
                const authRes = await axios.post('https://publisher.cashbolt.in.net/server/', {
                    action: 'checkAuth',
                    authToken
                });

                if (!authRes.data.status) {
                    navigate('/login');
                    return;
                }
                setUser(authRes.data.res);

                // 2. Get Current Global Postback
                const pbRes = await axios.post('https://publisher.cashbolt.in.net/server/', {
                    action: 'getGlobalPostback',
                    authToken
                });

                if (pbRes.data.status) {
                    setGlobalPostback(pbRes.data.url || '');
                }

            } catch (error) {
                toast.error('Failed to load postback data');
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [navigate]);

    // --- Test Action (FIXED) ---
    const handleTest = async () => {
        if (!globalPostback.trim()) return toast.warning('Enter a URL to test');

        setTestLoading(true);
        setTestResult(null); // Clear previous result
        const authToken = getCookie('authToken');

        try {
            const res = await axios.post('https://publisher.cashbolt.in.net/server/', {
                action: 'testGlobalPostback',
                authToken,
                url: globalPostback
            });

            if (res.data.status) {
                toast.success('Test Fired Successfully');
            } else {
                toast.warning('Test Fired but received error response');
            }

            // --- FIX: Update state with server response so the terminal shows up ---
            setTestResult({
                success: res.data.status,
                httpCode: res.data.http_code || 200, // Use 200 if server doesn't send specific code
                responseBody: res.data.response_body || 'Success (No content returned)',
                firedUrl: globalPostback
            });

        } catch (err) {
            // Handle Network Errors
            setTestResult({
                success: false,
                httpCode: 0,
                responseBody: 'Network Error or Timeout',
                firedUrl: globalPostback
            });
        } finally {
            setTestLoading(false);
        }
    };

    if (loading) return <Loader />;

    return (
        <div className="pb-page-wrapper-unique">
            <div className="bg-shape-pb shape-1-pb"></div>
            <div className="bg-shape-pb shape-2-pb"></div>
            <Navbar name={user?.name} role={user?.role} />

            <div className="pb-container-unique">

                <div className="pb-header-unique">
                    <h2>Test Global Postback</h2>
                    <p>Send a test ping to verify your integration.</p>
                </div>

                <div className="pb-card-unique main-card">

                    <div className="form-section">
                        <label className="pb-label">Testing URL</label>
                        <div className="input-group-pb">
                            <span className="icon-pb">🔗</span>
                            <input
                                type="text"
                                placeholder="https://your-tracker.com/postback..."
                                value={globalPostback}
                                onChange={(e) => setGlobalPostback(e.target.value)}
                            />
                        </div>
                    </div>

                    <div className="action-row-unique">
                        <button
                            className="test-btn-unique"
                            onClick={handleTest}
                            disabled={testLoading}
                            style={{ width: '100%' }}
                        >
                            {testLoading ? 'FIRING...' : '⚡ TEST FIRE'}
                        </button>
                    </div>

                    {/* --- Test Response Terminal --- */}
                    {testResult && (
                        <div className={`test-terminal-unique ${testResult.success ? 'success' : 'error'}`}>
                            <div className="terminal-header">
                                <span className="status-dot"></span>
                                <span>Server Response: {testResult.httpCode}</span>
                            </div>
                            <div className="terminal-body">
                                <div className="term-row">
                                    <span className="term-key">Fired URL:</span>
                                    <span className="term-val url">{testResult.firedUrl}</span>
                                </div>
                                <div className="term-row">
                                    <span className="term-key">Response:</span>
                                    <span className="term-val">{testResult.responseBody}</span>
                                </div>
                            </div>
                        </div>
                    )}

                </div>
                <div className="pb-card-unique macros-card">
                    <h3 className="card-title-pb">Available Macros</h3>
                    <p className="macros-desc">Use these placeholders in your URL. They will be replaced dynamically.</p>

                    <div className="macros-grid-unique">
                        <MacroItem name="{aff_click_id}" desc="Your unique Click ID" />
                        <MacroItem name="{sub_aff_id}" desc="Your unique Click ID 2" />
                        <MacroItem name="{camp_id}" desc="ID of the converted offer" />
                        <MacroItem name="{event}" desc="Event / goal name" />
                        <MacroItem name="{aff_sub1}....{aff_sub6}" desc="Custom params to pass extra details" />
                        <MacroItem name="{ip}" desc="Click IP Address" />
                        <MacroItem name="{device}" desc="User Device Type" />
                    </div>
                </div>
            </div>
        </div>
    );
};
const MacroItem = ({ name, desc }) => (
    <div className="macro-item-unique">
        <span className="macro-tag">{name}</span>
        <span className="macro-info">{desc}</span>
    </div>
);
export default TestPostback;